import { signal } from "@preact/signals-react"

export const isLoadingMonth = signal(false)
export const monthSearches = signal(0)
export const userSiteTableData = signal([])
export const dateUserTableData = signal({})
export const isDateRangeLoading = signal(false)
export const reportSearchSummaryID = signal(null)
export const reportListData = signal([])
// the running rows of the home table register their execution here and read their status back;
// one status-multiple poll (useManageHomeStatus) serves all of them
export const homeRunningExecutions = signal([])
export const homeRunningStatus = signal({})
